/* WP-10 display preferences (§14.5.5): large-text + contrast toggles applied
 * as html classes; persisted in localStorage, applied at boot before paint. */

const LARGE_TEXT_KEY = 'hp.largeText';
const CONTRAST_KEY = 'hp.contrast';

export type DisplayPref = { cls: 'hp-large-text' | 'hp-contrast'; key: string };

export const DISPLAY_PREFS: Record<'largeText' | 'contrast', DisplayPref> = {
  largeText: { cls: 'hp-large-text', key: LARGE_TEXT_KEY },
  contrast: { cls: 'hp-contrast', key: CONTRAST_KEY },
};

/** Applies persisted display prefs at boot (called from main.tsx). */
export function applyDisplayPrefs(): void {
  try {
    if (localStorage.getItem(LARGE_TEXT_KEY) === '1') {
      document.documentElement.classList.add('hp-large-text');
    }
    if (localStorage.getItem(CONTRAST_KEY) === '1') {
      document.documentElement.classList.add('hp-contrast');
    }
  } catch {
    /* storage unavailable — prefs stay session-local */
  }
}

/** Toggles one pref; persists the choice (best-effort). */
export function setDisplayPref(pref: DisplayPref, on: boolean): void {
  document.documentElement.classList.toggle(pref.cls, on);
  try {
    if (on) localStorage.setItem(pref.key, '1');
    else localStorage.removeItem(pref.key);
  } catch {
    /* ignore */
  }
}
